<script lang="ts" context="module">
  import { reactiveContext } from "#lib/internal/helpers"

  export type AccordionItemProps = CollapsibleRootProps & {
    value: string | number
  }

  type ItemContext = {
    readonly value: string | number
  }

  const { getContext, setContext } = reactiveContext<ItemContext>()
  export const getItemContext = getContext
</script>

<script lang="ts">
  import {
    Collapsible,
    type CollapsibleRootProps,
  } from "#lib/internal/components/collapsible/index"
  import { cn } from "#lib/utils"
  import { getRootCtx } from "./AccordionRoot.svelte"

  type $$Props = AccordionItemProps

  let className: $$Props["class"] = undefined
  export { className as class }
  export let value: $$Props["value"]

  const rootCtx = getRootCtx()

  $: isOpen = Array.isArray($rootCtx.value)
    ? ($rootCtx.value as (string | number)[]).includes(value)
    : $rootCtx.value === value

  const itemCtx = setContext()
  $: itemCtx.set({ value })
</script>

<Collapsible.Root
  open={isOpen}
  disabled={$rootCtx.disabled}
  class={cn("border-b", className)}
  {...$$restProps}
>
  <slot />
</Collapsible.Root>
